import React from 'react';

interface IPropsAbsoluteCenter {
    children?: React.ReactNode;
    size: number;
    top: number;
}

export const AbsoluteCenter: React.FC<IPropsAbsoluteCenter> = ({ children, size, top }) => {
    return (
        <div className="absolute-center" style={{ maxWidth: `${size}rem`, paddingTop: `${top}rem` }}>
            {children}
        </div>
    );
};
